'use client';
/**
 * Экспериментальная 53-битная хэш-функция.
 * Оптимальна по скорости работы / числу коллизий согласно
 * https://github.com/bryc/code/blob/master/jshash/hashes/README.md
 *
 * @param seed {0}
 * */ var cyrb53 = function(value, seed) {
    if (seed === void 0) seed = 0;
    var h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for(var i = 0, ch; i < value.length; i++){
        ch = value.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 0x85ebca77);
        h2 = Math.imul(h2 ^ ch, 0xc2b2ae3d);
    }
    h1 ^= Math.imul(h1 ^ h2 >>> 15, 0x735a2d97);
    h2 ^= Math.imul(h2 ^ h1 >>> 15, 0xcaf649a9);
    h1 ^= h2 >>> 16;
    h2 ^= h1 >>> 16;
    return 2097152 * (h2 >>> 0) + (h1 >>> 11) >>> 1;
};

export { cyrb53 };
